import ReactPixel from 'react-facebook-pixel';

import { checkoutComplete_checkoutComplete_order } from '@components/pages/CheckoutPage/__generated__/checkoutComplete';
import { orderPaymentComplete_orderPaymentComplete_order } from '@components/pages/OrderDetailPage/__generated__/orderPaymentComplete';
import { getDBIdFromGraphqlId } from '@src/core/utils';

export const pixelAddToCart = (variantSku: string, productName: string, categoryName: string, price: number) => {
  ReactPixel.track('AddToCart', {
    content_name: productName,
    content_category: categoryName,
    content_ids: [variantSku],
    content_type: 'product',
    value: price,
    currency: 'INR',
  });
};

export const pixelContentView = (
  productName: string,
  categoryName: string,
  variantSku: string,
  contentType: string,
  currency: string = 'INR',
) => {
  ReactPixel.track('ViewContent', {
    content_name: productName,
    content_category: categoryName,
    content_ids: [variantSku],
    content_type: contentType,
    currency,
  });
};

export const pixelPurchase = (
  data: checkoutComplete_checkoutComplete_order | orderPaymentComplete_orderPaymentComplete_order,
  currency: string = 'INR',
) => {
  const flatLines = data?.subs?.flatMap((sub) => sub.lines);
  const variantSkuList = flatLines?.map((line) => line?.variant?.sku);

  ReactPixel.track('Purchase', {
    content_ids: variantSkuList,
    value: data?.total?.gross?.amount,
    currency,
  });
};

export const pixelSearch = (search_string: string) => {
  ReactPixel.track('Search', {
    search_string,
  });
};

export const pixelCompleteRegistration = (content_name: string) => {
  ReactPixel.track('CompleteRegistration', {
    content_name,
  });
};

export const pixelInitiateCheckout = (orderData: checkoutComplete_checkoutComplete_order, currency: string = 'INR') => {
  const flatLines = orderData?.subs?.flatMap((sub) => sub.lines);
  const variantSkuList = flatLines?.map((line) => line?.variant?.sku);
  const totalQuantity = flatLines?.reduce((sum, line) => sum + (line?.quantity || 0), 0) || 0;

  ReactPixel.track('InitiateCheckout', {
    content_ids: variantSkuList,
    num_items: totalQuantity,
    value: orderData?.total?.gross?.amount || 0,
    currency,
  });
};
